// extracted by mini-css-extract-plugin
export var divider = "_tn-0";